const INTERNAL_SLUGS = new Set(['architecture-validation']);

const CATEGORY_SCORE = 3;
const KEYWORD_SCORE = 2;
const NAME_WORD_SCORE = 1;
const MAX_KEYWORD_HITS = 3;

function nameWords(name) {
  return (name || '').split(/\s+/).filter(word => word.length > 2);
}

function scoreCandidate(current, candidate) {
  let score = 0;

  if (candidate.category && candidate.category === current.category) {
    score += CATEGORY_SCORE;
  }

  const currentKeywords = new Set(current.keywords || []);
  let shared = 0;
  for (const keyword of candidate.keywords || []) {
    if (currentKeywords.has(keyword)) shared++;
  }
  score += Math.min(shared, MAX_KEYWORD_HITS) * KEYWORD_SCORE;

  const currentWords = new Set(nameWords(current.name));
  for (const word of nameWords(candidate.name)) {
    if (currentWords.has(word)) score += NAME_WORD_SCORE;
  }

  return score;
}

export function getRelatedTools(currentTool, allTools, limit = 4) {
  if (!currentTool || !Array.isArray(allTools)) return [];
  const max = Number.isInteger(limit) && limit > 0 ? limit : 4;

  const scored = [];
  for (const tool of allTools) {
    if (!tool || tool.id === currentTool.id) continue;
    if (INTERNAL_SLUGS.has(tool.slug)) continue;
    const score = scoreCandidate(currentTool, tool);
    if (score > 0) scored.push({ tool, score });
  }

  scored.sort((a, b) => {
    if (b.score !== a.score) return b.score - a.score;
    return a.tool.slug.localeCompare(b.tool.slug);
  });

  return scored.slice(0, max).map(entry => entry.tool);
}
